var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * 
 * @file Preview sidebar component
 * @author Box
 */

import * as React from 'react';
import DetailsSidebar from './DetailsSidebar';
import SkillsSidebar from './SkillsSidebar';
import ActivitySidebar from './ActivitySidebar';
import MetadataSidebar from './MetadataSidebar';
import SidebarNav from './SidebarNav';
import { SIDEBAR_VIEW_SKILLS, SIDEBAR_VIEW_ACTIVITY, SIDEBAR_VIEW_DETAILS, SIDEBAR_VIEW_METADATA } from '../../constants';


var Sidebar = function Sidebar(_ref) {
    var view = _ref.view,
        currentUser = _ref.currentUser,
        file = _ref.file,
        getPreview = _ref.getPreview,
        getViewer = _ref.getViewer,
        hasMetadata = _ref.hasMetadata,
        hasActivityFeed = _ref.hasActivityFeed,
        hasSkills = _ref.hasSkills,
        hasDetails = _ref.hasDetails,
        activitySidebarProps = _ref.activitySidebarProps,
        detailsSidebarProps = _ref.detailsSidebarProps,
        metadataSidebarProps = _ref.metadataSidebarProps,
        onToggle = _ref.onToggle,
        onVersionHistoryClick = _ref.onVersionHistoryClick;
    return React.createElement(
        React.Fragment,
        null,
        React.createElement(SidebarNav, {
            onToggle: onToggle,
            selectedView: view,
            hasSkills: hasSkills,
            hasMetadata: hasMetadata,
            hasActivityFeed: hasActivityFeed,
            hasDetails: hasDetails
        }),
        view === SIDEBAR_VIEW_DETAILS && hasDetails && React.createElement(DetailsSidebar, _extends({
            key: file.id,
            file: file,
            onVersionHistoryClick: onVersionHistoryClick
        }, detailsSidebarProps)),
        view === SIDEBAR_VIEW_SKILLS && hasSkills && React.createElement(SkillsSidebar, {
            key: file.id,
            file: file,
            getPreview: getPreview,
            getViewer: getViewer
        }),
        view === SIDEBAR_VIEW_ACTIVITY && hasActivityFeed && React.createElement(ActivitySidebar, _extends({
            key: file.id,
            currentUser: currentUser,
            file: file,
            onVersionHistoryClick: onVersionHistoryClick
        }, activitySidebarProps)),
        view === SIDEBAR_VIEW_METADATA && hasMetadata && React.createElement(MetadataSidebar, _extends({
            key: file.id,
            file: file
        }, metadataSidebarProps))
    );
};

export default Sidebar;